import axios from "@/api/config";

const dictionary = {
  getDictionaryById(data) {
    return axios.get(
      `${process.env.BASE_URL}/dictionary/getDictionary/` + data,
      {}
    );
  },
  getTempDictionaryData(data) {
    return axios.get(
      `${process.env.BASE_URL}/dictionary/getPcPageTemplateList`,
      {
        params: data
      }
    );
  },
  getDictionary(data) {
    return axios.get(`${process.env.BASE_URL}/dictionary/getDictionary`, {
      params: data
    });
  },
  getDictionaryList(data) {
    return axios.get(`${process.env.BASE_URL}/dictionary/getDictionaryList`, {
      params: data
    });
  },
  getDictionaryTreeByParentId(data) {
    return axios.get(
      `${process.env.BASE_URL}/dictionary/getDictionaryTreeByParentId`,
      {
        params: data
      }
    );
  },
  getDictionaryListByParentId(data) {
    return axios.get(
      `${process.env.BASE_URL}/dictionary/getDictionaryListByParentId`,
      {
        params: data
      }
    );
  },
  getDictionaryTreeListByParentId(data) {
    return axios.get(
      `${process.env.BASE_URL}/dictionary/getDictionaryListByParentId`,
      {
        params: data
      }
    );
  },
  getDictionaryTree(data) {
    return axios.get(`${process.env.BASE_URL}/dictionary/getDictionaryTree`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/dictionary/pageList`, data);
  },
  addDictionary(data) {
    return axios.post(`${process.env.BASE_URL}/dictionary/addDictionary`, data);
  },
  updateDictionary(data) {
    return axios.put(
      `${process.env.BASE_URL}/dictionary/updateDictionary`,
      data
    );
  },
  deleteDictionary(data) {
    return axios.delete(`${process.env.BASE_URL}/dictionary/deleteDictionary`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/dictionary/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/dictionary/importData`, data);
  },
  enabledDictionary(data) {
    return axios.post(
      `${process.env.BASE_URL}/dictionary/enabledDictionary`,
      data
    );
  }
};

export default dictionary;



// WEBPACK FOOTER //
// ./src/api/dictionary.js